import * as React from 'react';
import Empty from '../empty';
import { ConfigConsumer } from '.';
const renderEmpty = (componentName, des) => (<ConfigConsumer>
    {({ getPrefixCls }) => {
        const prefix = getPrefixCls('empty');
        switch (componentName) {
            case 'Table':
            case 'List':
                return <Empty />;
            case 'Select':
            case 'Cascader':
                return (<Empty className={`${prefix}-small`} description={des || undefined} imageStyle={{ display: 'none' }}/>);
            case 'TreeSelect':
            case 'Transfer':
            case 'Mentions':
                return <Empty className={`${prefix}-small`} description={des || undefined}/>;
            default:
                return <Empty />;
        }
    }}
  </ConfigConsumer>);
export default renderEmpty;
